import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InfiniteScroll from 'react-infinite-scroll-component';
import { List, Skeleton } from 'antd';

import * as actions from '../store/actions/chat-history';
import MessageItem from './message-item';

import DateDivider from './date-divider';
import moment from 'moment';
import ScrollToBottomButton from './ScrollToBottomButton';
import { AppDispatch, RootState } from '../../../store';

import './styles.less';

const usersCache: Record<string, { avatarColor: string; initial: string }> = {};

//to change
const stringToColor = (string: string) => {
  let hash = 0;

  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  const color =
    '#' +
    ((hash >> 24) & 0xff).toString(16).padStart(2, '0') +
    ((hash >> 16) & 0xff).toString(16).padStart(2, '0') +
    ((hash >> 8) & 0xff).toString(16).padStart(2, '0');

  return color;
};

const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('');
};

const getCachedUserData = (user: string, userId: string) => {
  const cacheKey = userId || `username-${user}`;

  if (usersCache[cacheKey]) return usersCache[cacheKey];

  const avatarColor = stringToColor(user);
  const initial = getInitials(user);

  usersCache[cacheKey] = { avatarColor, initial };

  return usersCache[cacheKey];
};

const pageSize = 10;

export type ChatHistoryComponentProps = {
  userType: number;
  selectedNewChatItem: any;
};

const ChatHistory = ({ userType, selectedNewChatItem }: ChatHistoryComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const [pageIndex, setPageIndex] = useState<number>(0);

  const chats = useSelector((state: RootState) => state.supportChat.chats);
  const messages = useSelector((state: RootState) => state.supportChat.messages);
  const messagesLoading = useSelector((state: RootState) => state.supportChat.messagesLoading);
  const messageItems = useSelector((state: RootState) => state.supportChat.localMessages);
  //const selectedMessageChatItem = useSelector((state: RootState) => state.supportChat.selectedMessageChatItem);

  useEffect(() => {
    if (chats) {
      //dispatch(actions.setMessages({})); //to unkomment when chat selection be ready
      fetchMessages({
        ChatId: chats.id,
        PageIndex: pageIndex,
        PageSize: pageSize,
      });
    }
  }, [chats]);

  useEffect(() => {
    //if (Array.isArray(messages?.messageList) && messages?.messageList?.length > 0) {
    if (messages && messages.messageList && messages.messageList.length > 0) {
      let newMessagesItem = { ...messageItems };

      if (Array.isArray(newMessagesItem?.messageList) && newMessagesItem?.messageList?.length > 0) {
        const loadedMessages = [...newMessagesItem.messageList];
        const isNewMessage = messages.messageList[0].createDate > loadedMessages[loadedMessages.length - 1].createDate;

        if (isNewMessage) {
          newMessagesItem.messageList = [...loadedMessages, ...messages.messageList];
        } else {
          newMessagesItem.messageList = [...messages.messageList, ...loadedMessages];
          newMessagesItem.hasMore = messages.hasMore;
        }
      } else {
        newMessagesItem = messages;
      }

      dispatch(actions.setLocalMessages(newMessagesItem));
    } else {
      let updatedMessagesItem = { ...messageItems };
      updatedMessagesItem.hasMore = false;
      dispatch(actions.setLocalMessages(updatedMessagesItem));
    }
  }, [messages]);

  const fetchMessages = (params: any) => {
    dispatch(actions.getMessages(params));
  };

  const loadMoreMessages = () => {
    setPageIndex((prevState) => prevState + 1);
    fetchMessages({
      ChatId: chats?.id,
      PageIndex: pageIndex + 1,
      PageSize: pageSize,
    });
  };

  return (
    <div>
      {messageItems && messageItems.messageList && messageItems.messageList.length > 0 && (
        <div id="messagesScrollableDivChatViwer" className="messages-roam-viever-scrollable-div custom-scrollbar">
          <InfiniteScroll
            className="messages-roam-viever-infinite-scroll"
            dataLength={messageItems?.messageList?.length || 0}
            next={loadMoreMessages}
            inverse={true}
            hasMore={messageItems?.hasMore && !messagesLoading}
            loader={<Skeleton paragraph={{ rows: 1 }} active />}
            scrollableTarget="messagesScrollableDivChatViwer"
          >
            {messageItems && messageItems.messageList && messageItems.messageList.length > 0 ? (
              <List
                itemLayout="horizontal"
                dataSource={messageItems?.messageList}
                rowKey={(record) => record.id}
                renderItem={(message, index) => {
                  const previousMessage = index > 0 ? messageItems?.messageList[index - 1] : null;
                  const isFirstMessageInList = index === 0 && !messageItems?.hasMore;
                  const isNewDay = isFirstMessageInList || (previousMessage && moment(message.createDate).isAfter(previousMessage.createDate, 'day'));

                  return (
                    <React.Fragment key={message.id}>
                      {isNewDay && <DateDivider date={message.createDate} />}
                      <MessageItem userType={userType} message={message} getCachedUserData={getCachedUserData} />
                    </React.Fragment>
                  );
                }}
              />
            ) : messagesLoading ? (
              <Skeleton paragraph={{ rows: 1 }} active />
            ) : (
              <p>No messages in the chat.</p> //todo style this component if no messages in the chat (need to test with empty chat)
            )}
          </InfiniteScroll>
          <ScrollToBottomButton scrollableDivId="messagesScrollableDivChatViwer" />
        </div>
      )}
    </div>
  );
};

export default ChatHistory;
